import * as React from "react";
import { observer } from "mobx-react";
import { Switch } from "@blueprintjs/core";
import { BootstrapTable, SearchField, TableHeaderColumn } from "react-bootstrap-table";
import { NotificacoesStore } from "../../stores/notificacoes/NotificacoesStore";

@observer
export default class Cron extends React.Component<{}, {}> {
  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    await NotificacoesStore.handleConsultaCrons();
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-cron"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar Módulo"
      />
    );
  };

  render() {

    let modulos = NotificacoesStore.obs.crons?.map(value => {
      return (value);
    });

    const options = {
      searchField: this.createCustomSearchField,
    };

    function buttonFormatter(cell, row) {
      return (
        <div>
          <Switch
            label={row.cron ? "Liberado" : "Bloqueado"}
            checked={row.cron}
            onChange={(e: any) => NotificacoesStore.changeStatusCron(row.id, e.target.checked)}
          />
        </div>
      );
    }

    function tipoFormatter(cell, row) {

      if(!cell) return ""

      return (cell.toUpperCase());

    }

    return (
      <>
        <BootstrapTable className="tabela-cron" ref="table" data={modulos} options={options} search>
          <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
          <TableHeaderColumn dataField="tipo" dataFormat={tipoFormatter} width="70%">Módulo</TableHeaderColumn>
          <TableHeaderColumn dataField="cron" dataFormat={buttonFormatter} width="30%">Cron</TableHeaderColumn>
        </BootstrapTable>
      </>
    )
  }
}